import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { ReactNode } from 'react';

import { persister } from './persister';
import {
  apiQueryClient,
  PERSISTED_API_QUERY_DEFAULT_CACHE_TIME,
  persistedApiQueryClient,
} from './queryClients';

const ENABLE_DEV_TOOLS = import.meta.env.VITE_DEV_TOOLS_ENABLED === 'true';

export function QueryProviders({ children }: { children: ReactNode }) {
  return (
    <PersistQueryClientProvider
      client={persistedApiQueryClient}
      persistOptions={{
        persister,
        maxAge: PERSISTED_API_QUERY_DEFAULT_CACHE_TIME,
        buster: __VERSION_HASH__,
      }}
    >
      <QueryClientProvider client={apiQueryClient}>
        {children}
        {ENABLE_DEV_TOOLS && (
          <>
            <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
            <ReactQueryDevtools
              client={persistedApiQueryClient}
              initialIsOpen={false}
              buttonPosition="bottom-right"
            />
          </>
        )}
      </QueryClientProvider>
    </PersistQueryClientProvider>
  );
}
